// extracted by mini-css-extract-plugin
module.exports = {"main":"OtpRemovePanel_main__XrDcU","content":"OtpRemovePanel_content__1R5R4","digitsTitle":"OtpRemovePanel_digitsTitle__1kwLU","error":"OtpRemovePanel_error__7dT0k"};